<div class="accountSection" *ngIf="subscription">
  <h2  i18n="@@Subscription">Subscription</h2>
  <p *ngIf="subscription.getSubscriptionStatus() === 'TRIAL'"><ng-container i18n="@@Your Main Organization Name Trial ends on">Your Main Organization Name Trial ends on</ng-container> {{subscription.paidUntilDate}}. <button (click)="subscription.setSubscriptionLevel('STARTER')" mat-button color="accent" i18n="@@Cancel subscription">Cancel subscription</button></p>
  <p *ngIf="subscription.getSubscriptionStatus() === 'EXPIRED'"><ng-container i18n="@@Your Main Organization Name subscription is expired.">Your Main Organization Name subscription is expired.</ng-container> <button mat-button color="primary" i18n="@@Update payment and billing information">Update payment and billing information</button></p>
  <p *ngIf="subscription.getSubscriptionStatus() === 'CURRENT'"><ng-container i18n="@@Your Main Organization Name Trial subscription will renew on">Your Main Organization Name Trial subscription will renew on</ng-container> {{subscription.paidUntilDate}}.</p>
  <mat-grid-list class="subscriptionOptions" cols="2" rowHeight="4:3" gutterSize="20px">
    <mat-grid-tile i18n-class="@@dir">
      <mat-card appearance="outlined" class="subscriptionOption">
        <mat-card-header>
          <mat-card-title i18n="@@Starter">Starter</mat-card-title>
          <mat-card-subtitle i18n="@@For staring users">For staring users</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <ul>
            <li i18n="@@Maximum of three titles">Maximum of three titles</li>
            <li i18n="@@Basic themes">Basic themes</li>
            <li i18n="@@Transcription per minute price">Transcription for $1.2/minute</li>
            <li i18n="@@Knowledge base for self-service">Knowledge base for self-service</li>
          </ul>
          <h2>$0 <span class="perMonth" i18n="@@/month">/month</span></h2>
        </mat-card-content>
        <mat-card-actions>
          <button *ngIf="subscription.getSubscriptionLevel() === 'STARTER'" mat-flat-button color="accent"><mat-icon>check</mat-icon> <span i18n="@@YOUR PLAN">YOUR PLAN</span></button>
          <button *ngIf="subscription.getSubscriptionLevel() !== 'STARTER'" (click)="subscription.setSubscriptionLevel('STARTER'); subscriptionService.changeSubscription(subscription);" mat-flat-button color="primary" i18n="@@CHANGE">Change</button>
        </mat-card-actions>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile i18n-class="@@dir">
      <mat-card appearance="outlined" class="subscriptionOption">
        <mat-card-header>
          <mat-card-title i18n="@@Standard">Standard</mat-card-title>
          <mat-card-subtitle i18n="@@For regular users">For regular users</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <ul>
            <li i18n="@@All the features of 'Starter'">All the features of 'Starter'</li>
            <li i18n="@@Unlimited number of titles">Unlimited number of titles</li>
            <li i18n="@@Basic stock image library">Basic stock image library</li>
            <li i18n="@@Email support">Email support</li>
            <li i18n="@@Upload logo image for use on covers">Upload logo image for use on covers</li>
          </ul>
          <h2>$20 <span class="perMonth" i18n="@@/month">/month</span></h2>
        </mat-card-content>
        <mat-card-actions>
          <button *ngIf="subscription.getSubscriptionLevel() === 'STANDARD'" mat-flat-button color="accent"><mat-icon>check</mat-icon> <span i18n="@@YOUR PLAN">YOUR PLAN</span></button>
          <button *ngIf="subscription.getSubscriptionLevel() !== 'STANDARD'" (click)="subscription.setSubscriptionLevel('STANDARD'); subscriptionService.changeSubscription(subscription);" mat-flat-button color="primary" i18n="@@CHANGE">Change</button>
        </mat-card-actions>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile i18n-class="@@dir">
      <mat-card appearance="outlined" class="subscriptionOption">
        <mat-card-header>
          <mat-card-title i18n="@@Plus">Plus</mat-card-title>
          <mat-card-subtitle i18n="@@For heavier users">For heavier users</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <ul>
            <li i18n="@@All the features of 'Standard'">All the features of 'Standard'</li>
            <li i18n="@@Expanded themes">Expanded themes</li>
            <li i18n="@@Expanded stock image library">Expanded stock image library</li>
            <li i18n="@@Upload custom images for use on covers">Upload custom images for use on covers</li>
            <li i18n="@@Ebooks">Ebooks</li>
            <li i18n="@@Support via phone">Support via phone</li>
          </ul>
          <h2>$49 <span class="perMonth" i18n="@@/month">/month</span></h2>
        </mat-card-content>
        <mat-card-actions>
          <button *ngIf="subscription.getSubscriptionLevel() === 'PLUS'" mat-flat-button color="accent"><mat-icon>check</mat-icon> <span i18n="@@YOUR PLAN">YOUR PLAN</span></button>
          <button *ngIf="subscription.getSubscriptionLevel() !== 'PLUS'" (click)="subscription.setSubscriptionLevel('PLUS'); subscriptionService.changeSubscription(subscription);" mat-flat-button color="primary" i18n="@@CHANGE">Change</button>
        </mat-card-actions>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile i18n-class="@@dir">
      <mat-card appearance="outlined" class="subscriptionOption">
        <mat-card-header>
          <mat-card-title i18n="@@Ecommerce">Ecommerce</mat-card-title>
          <mat-card-subtitle i18n="@@For online sales">For online sales</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <ul>
            <li i18n="@@All the features of 'Plus'">All the features of 'Plus'</li>
            <li i18n="@@Online ecommerce">Online ecommerce</li>
          </ul>
          <h2>$99 <span class="perMonth" i18n="@@/month">/month</span></h2>
        </mat-card-content>
        <mat-card-actions>
          <button *ngIf="subscription.getSubscriptionLevel() === 'ECOMMERCE'" mat-flat-button color="accent"><mat-icon>check</mat-icon> <span i18n="@@YOUR PLAN">YOUR PLAN</span></button>
          <button *ngIf="subscription.getSubscriptionLevel() !== 'ECOMMERCE'" (click)="subscription.setSubscriptionLevel('ECOMMERCE'); subscriptionService.changeSubscription(subscription);" mat-flat-button color="primary" i18n="@@CHANGE">Change</button>
        </mat-card-actions>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile *ngIf="startupService.getSubscription().getSubscriptionLevel() === 'ECOMMERCE' || startupService.getSubscription().getSubscriptionLevel() === 'DESIGNER' || startupService.admin">
      <mat-card appearance="outlined" class="subscriptionOption">
        <mat-card-header>
          <mat-card-title i18n="@@Designer">Designer</mat-card-title>
          <mat-card-subtitle i18n="@@For template creators.">For template creators.</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <ul>
            <li i18n="@@All the features of ecommerce">All the features of ecommerce</li>
            <li i18n="@@Features to create interior and cover templates.">Features to create interior and cover templates.</li>
          </ul>
          <h2>$199 <span class="perMonth" i18n="@@/month">/month</span></h2>
        </mat-card-content>
        <mat-card-actions>
          <button *ngIf="subscription.getSubscriptionLevel() === 'DESIGNER'" mat-flat-button color="accent"><mat-icon>check</mat-icon> <span i18n="@@YOUR PLAN">YOUR PLAN</span></button>
          <button *ngIf="subscription.getSubscriptionLevel() !== 'DESIGNER'" (click)="subscription.setSubscriptionLevel('DESIGNER'); subscriptionService.changeSubscription(subscription);" mat-flat-button color="primary" i18n="@@CHANGE">Change</button>
        </mat-card-actions>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>

